import { render } from "./iconIsotipoLogo.vue?vue&type=template&id=18822812&scoped=true"
import script from "./iconIsotipoLogo.vue?vue&type=script&lang=js"
export * from "./iconIsotipoLogo.vue?vue&type=script&lang=js"

import "./iconIsotipoLogo.vue?vue&type=style&index=0&id=18822812&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18822812"

export default script